import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { api } from "./lib/api";
import { Toaster } from "sonner";
import { LangProvider } from "./i18n/LangContext";
import { AuthProvider } from "./context/AuthContext";
import { AuthCallback } from "./components/auth/AuthCallback";
import Home from "./pages/Home";
import AdminPage from "./pages/Admin";
import ProPage from "./pages/ProPage";
import ResetPasswordPage from "./pages/ResetPassword";
import { WhatsAppFab } from "./components/site/WhatsAppFab";

const usePageTracking = (pathname) => {
  useEffect(() => {
    if (pathname.startsWith("/admin")) return;
    api.post("/track", { path: pathname, referrer: document.referrer || null, lang: localStorage.getItem("indushub_lang") || "fr" }).catch(() => {});
  }, [pathname]);
};

function AppRouter() {
  const location = useLocation();
  usePageTracking(location.pathname);
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <>
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/espace" element={<ProPage />} />
      <Route path="/admin" element={<AdminPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="*" element={<Home />} />
    </Routes>
    {!location.pathname.startsWith("/admin") && <WhatsAppFab />}
    </>
  );
}

function App() {
  return (
    <LangProvider>
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
        </BrowserRouter>
      </AuthProvider>
      <Toaster theme="dark" position="bottom-right" toastOptions={{ style: { background: "#1D2731", border: "1px solid rgba(230,236,240,0.16)", color: "#EDEFF1", fontFamily: "IBM Plex Sans" } }} />
    </LangProvider>
  );
}

export default App;
